export default "__VITE_ASSET__GOmjWFgg__"